import useCommonCollectionQuery from "@repo/shopify/queries/useCollectionQuery";
import type { IUseCollectionQuery } from "@repo/shopify/types/queries";

import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function useCollection(params?: Pick<IUseCollectionQuery, "skipCollectionList" | "skipFilters" | "collection">) {
  const { lang } = useLanguage();
  const { openToast } = useLayoutStore();

  return useCommonCollectionQuery({
    ...params,
    lang,
    openToast,
  });
}
